


















/**
 * kd-button封装
 */

import { Vue, Prop, Component } from 'vue-property-decorator';
@Component({})
export default class KdButton extends Vue {
  /** 按钮类型 */
  @Prop({ default: 'primary' }) public type!: 'primary';
  /** 是否可以点击样式 */
  @Prop({ default: false }) public disabled!: boolean;
  /** 是否可以点击中 */
  @Prop({ default: false }) public isCanClick!: boolean;
  /** 是否为圆弧 */
  @Prop({ default: true }) public round!: boolean;
  /** 按钮样式覆盖 */
  @Prop({ default: '' }) public styleString!: string;

  public btnClick() {
    if (!this.isCanClick) {
      this.$emit('click');
    }
  }
}
